import script from "./delivery-service-detail-x.vue?vue&type=script&lang=ts&setup=true"
export * from "./delivery-service-detail-x.vue?vue&type=script&lang=ts&setup=true"

import "./delivery-service-detail-x.vue?vue&type=style&index=0&id=25642acd&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25642acd"]])

export default __exports__